import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchExternalMediaTypes = async ({ type, trialId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (!!trialId) params.append("trial", trialId);

  const URL = `${__API_URL__}/api/photos/get_external_media_types/${type}?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetExternalMediaTypes = ({ type, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["external_media_types", type, trialId],
    queryFn: () => fetchExternalMediaTypes({ type, trialId }),
    enabled: enabled && Boolean(trialId && trialId > 0),
  });
};

export default useGetExternalMediaTypes;
